import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPseudoCheckboxModule, MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { NoItemPlaceholderModule } from '@portal-core/general/components/no-item-placeholder/no-item-placeholder.module';
import { StopPropagationModule } from '@portal-core/general/directives/stop-propagation/stop-propagation.module';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { LicenseUsersSelectListModule } from '@portal-core/license-users/components/license-users-select-list/license-users-select-list.module';
import { LicenseUserAsyncModule } from '@portal-core/license-users/pipes/license-user-async/license-user-async.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { ProjectLicenseUsersListModule } from '@portal-core/projects/components/project-license-users-list/project-license-users-list.module';
import { ProjectTeamsListModule } from '@portal-core/projects/components/project-teams-list/project-teams-list.module';
import { TeamAvatarModule } from '@portal-core/teams/components/team-avatar/team-avatar.module';
import { TeamsSelectListModule } from '@portal-core/teams/components/teams-select-list/teams-select-list.module';
import { TeamAsyncModule } from '@portal-core/teams/pipes/team-async/team-async.module';
import { AutocompleteInputModule } from '@portal-core/ui/autocomplete/components/autocomplete-input/autocomplete-input.module';
import { DropdownArrowModule } from '@portal-core/ui/forms/components/dropdown-arrow/dropdown-arrow.module';
import { FilterBarModule } from '@portal-core/ui/page-filters/components/filter-bar/filter-bar.module';
import { PopupModule } from '@portal-core/ui/popup/popup.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { ProjectAccessFormComponent } from './project-access-form.component';

@NgModule({
  declarations: [ProjectAccessFormComponent],
  imports: [
    McColorModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    FormsModule,
    LoaderModule,
    NoItemPlaceholderModule,
    ProjectAvatarModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatListModule,
    MatProgressBarModule,
    MatPseudoCheckboxModule,
    MatRippleModule,
    MatTabsModule,
    StopPropagationModule,
    TeamAvatarModule,
    TeamAsyncModule,
    LicenseUserAsyncModule,
    LicenseUserAvatarModule,
    PopupModule,
    DropdownArrowModule,
    TeamsSelectListModule,
    FilterBarModule,
    ProjectTeamsListModule,
    ProjectLicenseUsersListModule,
    AutocompleteInputModule,
    MatFormFieldModule,
    MatInputModule,
    LicenseUsersSelectListModule
  ],
  exports: [ProjectAccessFormComponent]
})
export class ProjectAccessFormModule { }
